module.exports = __webpack_public_path__ + "static/media/ic_check_mark.c818b33a.svg";